export default __webpack_public_path__ + "static/media/instagram.d256fe5d.png";